<button id="submit-button" class="btn-submit btn w-100 btn-primary fw-semibold" [type]="type" [disabled]="submitting" (click)="click()">
    <div flexLayout="row">
        <p class="button-content">{{text}}
            <span *ngIf="submitting">
                <i class="fa fa-spinner fa-spin"></i>
            </span>
        </p>
    </div>
</button>